<template>
  <div class="cropper-content">
        <div class="cropper" style="text-align:center">
          <cropper
            :imgurl="tailorimg"
            @upload_success="onMobileCoverImageUploadSuccess"
          />
        </div>
      </div>
</template>

<script>
import cropper from '@/components/cropper.vue'
export default {
  components: {
    cropper
  },
  methods:{
      onMobileCoverImageUploadSuccess(res){
          this.$emit('close',res)
      }
  }
}
</script>

<style lang="scss" scoped>

// 截图
.cropper-content {
    .cropper {
        width: auto;
        height: 400px;
    }
}
</style>